import { makeAutoObservable } from 'mobx';
import { Client } from 'react-stomp-hooks';

import { WEBSOCKET_DESTINATION_PREFIX } from '../constants';
import { waitUntil } from '../utils/async.utils';
import localStorageStore from './LocalStorageStore';
import { StateStore } from './StateStore';

interface EventTableLock {
  tableId: string;
}

class WebsocketStore implements StateStore {
  private activeDestinations: string[] = [];

  private eventLock: EventTableLock[] = [];

  public constructor() {
    makeAutoObservable(this);
  }

  public resetState = (): void => {
    this.activeDestinations = [];
    this.eventLock = [];
  };

  public sendEvent = (
    stompClient: Client,
    destination: string,
    request?: any,
  ): void =>
    stompClient.publish({
      destination: `${WEBSOCKET_DESTINATION_PREFIX}${destination}`,
      body: request ? JSON.stringify(request) : undefined,
      headers: { Authorization: localStorageStore.getToken() },
    });

  public acquireTableLock = async (tableId: string): Promise<void> => {
    return waitUntil(
      () => !this.eventLock.find(lock => lock.tableId === tableId),
    ).then(() => {
      this.eventLock.push({ tableId });
    });
  };

  public releaseTableLock = (tableId: string): void => {
    const indexToRemove = this.eventLock.findIndex(
      lock => lock.tableId === tableId,
    );
    if (indexToRemove > -1) {
      this.eventLock.splice(indexToRemove, 1);
    }
  };

  public addDestination = (destination: string): boolean => {
    if (!this.checkIfDestinationSubscribed(destination)) {
      this.activeDestinations.push(destination);
      return true;
    }
    return false;
  };

  public removeDestination = (destination: string): void => {
    this.activeDestinations = this.activeDestinations.filter(
      d => d !== destination,
    );
  };

  private checkIfDestinationSubscribed = (destination: string): boolean =>
    this.activeDestinations.includes(destination);
}

const websocketStore = new WebsocketStore();
export default websocketStore;
